import { render, staticRenderFns } from "./CellManager.vue?vue&type=template&id=70d502ba&scoped=true&"
import script from "./CellManager.vue?vue&type=script&lang=ts&"
export * from "./CellManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d502ba",
  null
  
)

export default component.exports